import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  CompanyPlanUpgradeFeatureEnum,
  AccessComponentEnum,
  AccessLevelEnum,
} from 'graphql-common';
import BreadCrumbs from '@lib/components/BreadCrumbs/BreadCrumbs';
import PageHeader from '@lib/layouts/DashboardLayout/PageHeader/PageHeader';
import PageBody from '@lib/layouts/DashboardLayout/PageBody/PageBody';
import Trans from '@lib/components/Trans/Trans';
import FeatureLockState from '@lib/components/FeatureLockState';
import { PlanState } from '@lib/enums/plan';
import { getBreadCrumbsDataByKey } from 'utils/breadcrumbs';
import useOutletContext, { ContextProps } from 'hooks/useOutletContext';
import DocumentCategoriesContent from './DocumentCategoriesContent';

export default function DocumentCategories() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { getUserAccessByCompany, handleOpenPlanModal }: ContextProps =
    useOutletContext();
  // Company-plan access is the authoritative source for the locked-feature
  // state — user-role permissions can't override a plan lock. (Same pattern
  // as DocumentApprovals / DocumentAnalytics.)
  const isPlanLocked =
    getUserAccessByCompany(AccessComponentEnum.DocumentationManagement) ===
    AccessLevelEnum.LimitedRead;

  if (isPlanLocked) {
    return (
      <>
        <BreadCrumbs data={getBreadCrumbsDataByKey({ pathname, t })} />
        <PageHeader title={t('categories')} />
        <PageBody>
          <FeatureLockState
            title={t('unlock-document-categories')}
            text={<Trans i18nKey="unlock-document-categories-text" />}
            onUpgrade={() =>
              handleOpenPlanModal(PlanState.Locked, [
                CompanyPlanUpgradeFeatureEnum.Documentation,
              ])
            }
          />
        </PageBody>
      </>
    );
  }

  return (
    <>
      <BreadCrumbs data={getBreadCrumbsDataByKey({ pathname, t })} />
      <DocumentCategoriesContent />
    </>
  );
}
